"use client";

import React, { useEffect, useState } from "react";
import { Box, Typography, Card, CardMedia, IconButton } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import axios from "axios";
import RbtThumbnail from "../assets/Rbt_Thumbnail.jpg";
import { useNavigate } from "react-router-dom";
import { RootState } from "../redux/store";
import { useSelector } from "react-redux";

interface Tone {
  rbtCode: string;
  imgPath: string;
  rbtName: string;
  artistName: string;
}

interface TonesSectionProps {
  title: string;
  tones?: Tone[];
  categoryId: number;
}

const TonesSection: React.FC<TonesSectionProps> = ({
  title,
  tones,
  categoryId,
}) => {

  const cleanTitle = title.replace(/\s+/g, "");
  const [rbts, setRbts] = useState<any[]>([]);
  const navigate = useNavigate();
  const { countryCode, msisdn } = useSelector(
    (state: RootState) => state.phone
  );
  

  const getRbts = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/Content/ToneListOfCategory?msisdn=${
        countryCode + msisdn
      }&service=${process.env.REACT_APP_SERVICE}&interface=${
        process.env.REACT_APP_INTERFACES
      }&langId=${
        process.env.REACT_APP_LANGID
      }&catId=${categoryId}&pageNo=-1&countryCode=${countryCode}&subType=P&planId=1&pageSize=10`
    );

    setRbts(res?.data?.toneListOfCategory);
  };

  useEffect(() => {
    getRbts();
  }, []);

  return (
    <Box sx={{ mb: 6, position: "relative" }}>
      <Typography
        variant="h5"
        sx={{
          mb: 2,
          color: "#0085CA",
          fontWeight: "bold", 
        }}
      >
        {title}
      </Typography>

      {
        rbts.length > 0 && (
      <Swiper
        modules={[Navigation, Autoplay]}
        spaceBetween={30}
        slidesPerView={4}
        slidesPerGroup={4}
        speed={800}
        navigation={{
          prevEl: `.prev-${cleanTitle}`,
          nextEl: `.next-${cleanTitle}`,
        }}
        autoplay={{ delay: 2000,  disableOnInteraction: false}}
        loop
        style={{ paddingBottom: "40px" }}
        breakpoints={{
          320: { slidesPerView: 1 },
          600: { slidesPerView: 2 },
          900: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
        }}
      >
        {rbts?.map((tone, i) => (
          <SwiperSlide key={i}>
            <Card
              sx={{
                backgroundColor: "transparent",
                overflow: "hidden",
                boxShadow: "none",
              }}
            >
              <Box
                sx={{
                  py: 1.3,
                  px: 1.5,
                  borderRadius: 2,
                  border: "1px solid #cfc2c2ff",
                }}
                onClick={() =>
                  navigate(
                    `/flowtone/detalle?rbtCode=${tone.rbtCode}&catId=${categoryId}`,
                    { state: tone }
                  )
                }
              >
                <CardMedia
                  component="img"
                  height="150"
                  image={RbtThumbnail}
                  alt={tone.rbtName}
                  sx={{ objectFit: "contain" }}
                />
              </Box>

              <Box
                sx={{
                  p: 1,
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  textAlignLast: "start",
                }}
              >
                <Typography fontSize={16} color="#0085CA" pt={1}>
                  {tone.rbtName}
                </Typography>
                <Typography variant="body2" color="text.black">
                  {tone.artistName}
                </Typography>
              </Box>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
        )
      }


      <IconButton
        className={`prev-${cleanTitle}`}
        sx={{
          position: "absolute",
          top: "-5%",
          left: "2%",
          transform: "translateY(-50%)",
          color: "#fff",
          transition: "all 0.3s ease",
          filter: "drop-shadow(0 0 3px rgba(0,0,0,0.7))",
          "&:hover": {
            transform: "translateY(-50%) scale(1.2)",
            opacity: 1,
            filter: "drop-shadow(0 0 8px rgba(0,176,255,0.9))",
            background: "none",
          },
        }}
      >
        <ArrowForwardIosIcon
          sx={{ transform: "rotate(180deg)", fontSize: 18 }}
        />
      </IconButton>

      <IconButton
        className={`next-${cleanTitle}`}
        sx={{
          position: "absolute",
          top: "-5%",
          right: "2%",
          transform: "translateY(-50%)",
          color: "#fff",
          transition: "all 0.3s ease",
          filter: "drop-shadow(0 0 3px rgba(0,0,0,0.7))",

          "&:hover": {
            transform: "translateY(-50%) scale(1.2)",
            opacity: 1,
            filter: "drop-shadow(0 0 8px rgba(0,176,255,0.9))",
            background: "none",
          },
        }}
      >
        <ArrowForwardIosIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Box>
  );
};

export default TonesSection;
